import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { aceGray, background, brandPrimary, charmGray, destructive, shuffleGray, titles } from '../../../styles/colors';
import { shadowSm } from '../../../styles/shadows';

export const s = StyleSheet.create({
	avatar: {
		width: 40,
		height: 40,
		flexShrink: 0,
	},
	contactCard: {
		width: `100%`,
		backgroundColor: 'white',
		boxShadow: shadowSm,
		border: `1px solid ${aceGray}`,
		padding: 16,
		maxWidth: 384,
		boxSizing: 'border-box',
		borderRadius: 8,
		cursor: 'pointer',
	},
	closeCustomContent: {
		width: 'fit-content',
		justifyContent: 'center',
	},
	errorMessageContainer: {
		borderRadius: 8,
		padding: 12,
		color: destructive,
		backgroundColor: `#fef2f2`,
		border: `1px solid ${destructive}`,
		width: `100%`,
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		boxSizing: 'border-box',
		alignItems: 'flex-start',
	},
	errorMessageDetails: {
		fontSize: 12,
		fontWeight: 'normal',
	},
	errorMessageButton: {
		backgroundColor: `white`,
		fontSize: 12,
	},
	flexCenter: {
		justifyContent: 'center',
		width: '100%',
	},
	inputContainer: {
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
	},
	aiKitCta: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		margin: `0 24px`,
		':has(*) > span': {
			flex: 1,
		},
		':has(*) > svg': {
			display: 'block',
			width: 20,
			height: 20,
		},
	},
	closeBtn: {
		position: `absolute`,
		top: 16,
		right: 18,
		padding: 0,
		color: charmGray,
		':has(*) > svg': {
			display: `block`,
			width: 12,
			height: 12,
		},
		// Show only on mobile
		[THEME.queries.md]: {
			display: 'block',
			right: 32,
		},
	},
	assistantEmail: {
		display: `flex`,
		flexDirection: `column`,
		gap: 16,
		fontWeight: `normal`,
	},
	useEmailBtn: {
		width: `100%`,
	},
	assistantMessageContent: {
		minWidth: 0,
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		lineHeight: 1.929,
		':has(*) p': {
			margin: 0,
			padding: 0,
		},
		':has(*) h1': {
			margin: 0,
			padding: 0,
		},
		':has(*) h2': {
			margin: 0,
			padding: 0,
		},
		':has(*) h3': {
			margin: 0,
			padding: 0,
		},
		':has(*) h4': {
			margin: 0,
			padding: 0,
		},
		':has(*) h5': {
			margin: 0,
			padding: 0,
		},
		':has(*) h6': {
			margin: 0,
			padding: 0,
		},
	},
	userMessage: {
		color: charmGray,
		fontSize: `0.875rem`,
		lineHeight: `1.714rem`,
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
	},
	assistantMessageSparkle: {
		flexShrink: 0,
	},
	assitantMessage: {
		display: `flex`,
		color: titles,
		gap: 4,
		fontSize: `0.875rem`,
		lineHeight: `1.25rem`,
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
	},
	root: {
		display: `flex`,
		height: `100%`,
	},
	sideContent: {
		flex: 1,
	},
	actionNav: {
		padding: `16px 8px`,
		display: `flex`,
		flexDirection: `column`,
		gap: 4,
		backgroundColor: background,
		borderLeft: `1px solid ${aceGray}`,
		height: `100%`,
	},
	tabActionButton: {
		padding: 8,
		display: `flex`,
		alignItems: `center`,
		justifyContent: `center`,
		borderRadius: 12,
		backgroundColor: 'white',
		border: `1px solid ${aceGray}`,
		[`:is([data-state="active"])`]: {
			backgroundColor: `#54a0d742`,
		},
	},
	chatWindow: {
		boxSizing: `border-box`,
		width: 390,
		height: `100%`,
		borderLeft: `1px solid ${aceGray}`,
		display: `flex`,
		flexDirection: `column`,
		paddingBottom: 8,
		position: `relative`,
		':has(*) p': {
			padding: 0,
			margin: 0,
		},
		[THEME.queries.md]: {
			width: '100%',
		},
	},
	universalChatWindow: {
		boxSizing: `border-box`,
		width: '100%',
		height: `100%`,
		display: `flex`,
		flexDirection: `column`,
		paddingBottom: 8,
		position: `relative`,
		':has(*) p': {
			padding: 0,
			margin: 0,
		},
	},
	chatContent: {
		flex: 1,
		display: `flex`,
		flexDirection: 'column',
		paddingTop: 16,
		paddingBottom: 16,
		overflowY: `auto`,
		gap: 16,
	},
	chatMessages: {
		display: `flex`,
		flexDirection: `column`,
		gap: 16,
		flex: 1,
		overflow: `auto`,
		padding: 16,
	},
	chatWindowHeader: {
		borderBottom: `1px solid ${aceGray}`,
		padding: `16px 24px`,
		display: `flex`,
		alignItems: `center`,
		justifyContent: `space-between`,
		gap: 8,
	},
	chatWindowHeaderStart: {
		display: `flex`,
		alignItems: `center`,
		gap: 8,
		color: brandPrimary,
	},
	leoAvatar: {
		width: 40,
		height: 40,
	},
	plusIconButton: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: 'transparent',
		border: 'none',
		padding: 6,
		margin: 0,
		cursor: 'pointer',
		':has(*) > svg': {
			display: 'block',
			width: 12,
			height: 12,
			fill: brandPrimary,
		},
	},
	chatWindowHeaderTitle: {
		fontSize: '1rem',
		lineHeight: '1.5rem',
		fontWeight: 'bold',
	},
	promptInput: {
		display: `block`,
		width: `100%`,
		boxSizing: `border-box`,
		backgroundColor: background,
		borderRadius: 8,
		resize: 'none',
		fieldSizing: 'content',
		maxHeight: 96,
		outline: 'none',
		padding: `12px 16px`,
		minHeight: 42,
		border: `1px solid rgb(233, 235, 239)`,
		'::placeholder': {
			color: charmGray,
		},
	},
	contactCardCompanyPill: {
		fontSize: '0.75rem',
		lineHeight: '1rem',
		padding: `4px 10px`,
		backgroundColor: shuffleGray,
		borderRadius: 16,
	},
});
